"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var ensureArray_1 = __importDefault(require("./utils/ensureArray"));
var some_1 = __importDefault(require("./utils/some"));
var branchIfFalsy = function (propName, _a) {
    var returnsOpt = (_a === void 0 ? {} : _a).returns;
    var propNames = ensureArray_1.default(propName);
    return ad_hok_1.branch(function (props) {
        return some_1.default(function (propName) { return !props[propName]; }, propNames);
    }, returnsOpt ? ad_hok_1.returns(returnsOpt) : ad_hok_1.renderNothing());
};
exports.default = branchIfFalsy;
